import theme from '../theme';

const preleadCategoryColor = (category: string) => {
  const preleadCategoryColors: {[key: string]: string} =
    theme.status.preleadCategory;
  return preleadCategoryColors[category];
};

export default preleadCategoryColor;
